'use strict'

// console.log('atScript');

/** Global var */
const _lang = document.querySelector('html').lang.split('-')[0];

/** Creating a link to the "Live Photos" of the product page */
// product-price.text-block
const ELEMENT_CONFIG = [
  {
    selector: 'product-card.product-card',
    linkSelector: 'a.contents[ref="cardGalleryLink"]',
    containerSelector: '.at-inner-container[data-role="has-live-photo-link"] rte-formatter.text-block',
    position: 'beforeend'
  }
];

/**
 * Note: For functions refStyling(), deliveryDate(), insertElement(), navInsertCollectionLink(), productCarousel(), 
 * MutationObserver is included in the file assets/at-mutation-observer.js
 */

function insertElement(root = document) {
  // console.log('containerSelector:', document.querySelectorAll('product-price'));

  ELEMENT_CONFIG.forEach(({ selector, linkSelector, containerSelector, position }) => {
    let cards = root.querySelectorAll(selector);

    cards.forEach(card => {
      // console.log('card', card.dataset.jsEnabled);
      if (card.dataset.jsEnabled === 'false') return;
      if (card.querySelector('.see-live-photos')) return;

      const container = card.querySelector(containerSelector);
      const link = card.querySelector(linkSelector);

      if (container && link) {
        const href = link.href + '#media-buttons-control';
        const html = `<span class="see-live-photos">
          <a title="See live photos" href="${href}">See live photos</a>
          <svg class="icon arrow-right-sm" width="20" height="20" viewBox="0 0 20 20" fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path d="M10.8333 5.625L15 10M15 10L10.8333 14.375M15 10L5 10" stroke="#485461" stroke-width="1.5"
              stroke-linecap="round" stroke-linejoin="round" />
          </svg>
        </span>`;
        container.insertAdjacentHTML(position, html);
      }
    });
  });
}
function initObserver() {
  insertElement();

  const observer = new MutationObserver((mutations) => {
    mutations.forEach(mutation => {
      mutation.addedNodes.forEach(node => {
        if (node.nodeType === 1) {
          if (node.matches && node.matches('product-card.product-card')) {
            insertElement(node.parentElement);
          } else {
            insertElement(node);
          }
        }
      });
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
}
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initObserver);
} else {
  initObserver();
}

function createSeeLink() {
  const cards = document.querySelectorAll('.new-arrivals-products product-card.product-card');
  cards.forEach(card => {
    const container = card.querySelector('product-price');
    const link = card.querySelector('a.contents[ref="cardGalleryLink"]');
    if (link) {
      const href = link.href;
      const html = `<span class="see-live-photos see-product">
        <a title="See product" href="${href}">See product
          <svg class="icon arrow-right-sm" width="20" height="20" viewBox="0 0 20 20" fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path d="M10.8333 5.625L15 10M15 10L10.8333 14.375M15 10L5 10" stroke="#485461" stroke-width="1.5"
              stroke-linecap="round" stroke-linejoin="round" />
          </svg>
        </a>
      </span>`;
      card.insertAdjacentHTML('beforeend', html);
    }
  });
}
['DOMContentLoaded', 'shopify:section:load'].forEach(event =>
  document.addEventListener(event, createSeeLink)
);

//===================

function productCarousel() {
  const wrappers = document.querySelectorAll('.resource-list.resource-list__carousel, main .resource-list.hidden--desktop'); // main - иначе распространяется на site header
  if (!wrappers.length) return;
  console.log('productCarousel is active');
  wrappers.forEach(wrapper => {
    const arrowsContainer = wrapper.querySelector('slideshow-arrows')
    const prevBtn = arrowsContainer.querySelector('button.slideshow-control--previous');
    const nextBtn = arrowsContainer.querySelector('button.slideshow-control--next');

    const slideshow = wrapper.querySelector('slideshow-slides');
    const slides = slideshow.querySelectorAll('slideshow-slide.resource-list__slide');
    if (!slides.length) return;

    const ACTION_CONFIG = [
      { e: 'mouseenter', v: '-1' },
      { e: 'mouseleave', v: '' }
    ];

    ACTION_CONFIG.forEach(({ e, v }) => {
      slideshow.addEventListener(e, () => {
        arrowsContainer.style.zIndex = v;
      });
    });

    function transform() {
      const gap = slideshow
        ? parseInt(getComputedStyle(slideshow).gap) || 0
        : 0;
      slides.forEach(slide => {
        slide.style.transform = `translateX(${-(slide.offsetWidth + gap) * n}px)`;
      });
    }

    const EVENT_CONFIG = [
      { selector: nextBtn, e: 'click' },
      { selector: prevBtn, e: 'click' }
    ];

    if (!nextBtn || !prevBtn) return;

    let k = 3; // for desktop

    // console.log('For desktop slide show number:', k);

    let n = 0;

    EVENT_CONFIG.forEach(({ selector, e }) => {
      selector.addEventListener(e, () => {
        if (selector === nextBtn && n < slides.length - 1 - k) {
          n++;
          transform();
          if (n < slides.length - 1 - k) selector.removeAttribute('disabled');
        }
        if (selector === prevBtn && n > 0) {
          n--;
          transform();
          if (n > 0) selector.removeAttribute('disabled');
        }
      });
    });
  });

}
if (window.matchMedia("(min-width: 750px)").matches) {
  ['DOMContentLoaded', 'shopify:section:load'].forEach(event =>
    document.addEventListener(event, productCarousel)
  );
}

function deliveryDate() {
  const cards = document.querySelectorAll('.product-card:not([data-delivery-processed]), .product-information:not([data-delivery-processed]');
  if (!cards.length) return;

  function getBusinessDate(daysToAdd) {
    let currentDate = new Date();
    let addedDays = 0;

    while (addedDays < daysToAdd) {
      currentDate.setDate(currentDate.getDate() + 1);
      let dayOfWeek = currentDate.getDay();

      if (dayOfWeek !== 0 && dayOfWeek !== 6) {
        addedDays++;
      }
    }

    return currentDate.toLocaleDateString('de-AT', {
      day: 'numeric',
      month: 'short',
      // year: 'numeric'
    });
  }

  cards.forEach(card => {
    const deliveris = card.querySelectorAll('.delivery-time');
    // const delivery = card.querySelector('product-price.text-block .delivery-time');
    const urgency = card.querySelector('span.custom-tag-badge.badge--in-stock');
    deliveris.forEach(delivery => {
      if (delivery.closest('.new-arrivals-products')) return;
      let note = '';
      if (delivery.closest('.product-details')) note = `<span style="font-size:85%"><strong>Bitte beachten Sie: </strong>Dieser Artikel ist nicht in unserem Geschäft vorrätig und nur auf Vorbestellung erhältlich.</span>`
      if (urgency && delivery) {
        // if (delivery.closest('product-price')) return;
        if (urgency.getAttribute('data-stock') !== 'in-stock') {
          delivery.insertAdjacentHTML('beforeend', `<i class="no-in-stock">${getBusinessDate(7)}</i>${note}`); // <small>nur an Wochentagen</small>
        } else {
          delivery.insertAdjacentHTML('beforeend', '<i class="in-stock">48 Std.</i>');
        }
      }
    });
    card.setAttribute('data-delivery-processed', 'true');

    const emptyElements = card.querySelectorAll('.release-and-condition');
    emptyElements.forEach(element => {
      if (!element.textContent.trim()) element.remove();
    });
  });
}
['DOMContentLoaded', 'shopify:section:load'].forEach(event =>
  document.addEventListener(event, deliveryDate)
);

function ProductDetailsIconInsert() {
  const containers = document.querySelectorAll('.has-icon');
  if (!containers) return;
  const ICON_TAXES = `<svg class="icon taxes" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M3.9999 14.9999V12.3312M9.33323 14.9999V12.3312M14.6666 14.9999V12.3312M19.9999 14.9999V12.3312M2.3999 18.3999H21.5999V21.5999H2.3999V18.3999ZM2.3999 8.7999V6.66657L11.6054 2.3999L21.5999 6.66657V8.7999H2.3999Z" stroke="#7F8790" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>`;
  const ICON_GUARANTEE = `<svg class="icon guarantee" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.59981 11.1876L11.3998 12.9876L14.9998 9.38763M4.7998 5.78763L10.3898 2.99261C11.4033 2.48586 12.5963 2.48586 13.6098 2.99261L19.1998 5.78763C19.1998 5.78763 19.1998 11.0436 19.1998 13.8156C19.1998 16.5876 16.6374 18.4588 11.9998 21.3876C7.36221 18.4588 4.7998 15.9876 4.7998 13.8156V5.78763Z" stroke="#7F8790" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
    `;
  containers.forEach(container => {
    const INSERT_ARR = [
      { conditionSelector: 'icon-taxes', icon: ICON_TAXES },
      { conditionSelector: 'icon-guarantee', icon: ICON_GUARANTEE }
    ];

    INSERT_ARR.forEach(({ conditionSelector, icon }) => {
      if (container.getAttribute('data-insert') === conditionSelector) container.insertAdjacentHTML('afterbegin', icon);
    });
  });
}
document.addEventListener('DOMContentLoaded', ProductDetailsIconInsert);
document.addEventListener('shopify:section:load', ProductDetailsIconInsert);

function refStyling() {
  const elements = document.querySelectorAll('[data-role="ref"]>*, [data-role="release"]>*');
  elements.forEach(element => {
    const em = element.querySelector('em');
    element.childNodes.forEach(node => {
      if (!node.textContent.trim()) em.style.color = '#cbcbcb';
      // if (!node.textContent.trim() && element.closest('.product-details')) element.parentElement.style.display = 'none';
    });
  });
}
['DOMContentLoaded', 'shopify:section:load'].forEach(event =>
  document.addEventListener(event, refStyling)
);


function newArrivalImageInsert() {
  document.querySelectorAll('.new-arrivals.has-scroll-slider').forEach(container => {
    const insertContainer = container.querySelector('[data-role="insert-container"]');
    if (!insertContainer) return;

    const rightGroup = container.querySelector('.group-block.group-right>.group-block-content');
    const scrollContainer = container.querySelector('html:not(.shopify-design-mode) .group-block.group-right .scroll-container');

    if ('scrollContainer', scrollContainer) {
      const baseImg = insertContainer.querySelector('img');
      const headingGroup = rightGroup?.querySelector('.heading-group');
      const blockHeight = baseImg?.getBoundingClientRect().height ?? 0;
      const headingHeight = headingGroup?.getBoundingClientRect().height ?? 0;
      const gap = rightGroup
        ? parseInt(getComputedStyle(rightGroup).gap) || 0
        : 0;

      scrollContainer.style.height = `${blockHeight - headingHeight - gap}px`;
      scrollContainer.title = 'Use mouse scrolling';
    }

    const observerOptions = { root: scrollContainer, threshold: 0.51 };

    container.querySelectorAll('[data-role="outer-container"]').forEach((outerContainer, i) => {
      outerContainer.dataset.index = i;

      const images = [...outerContainer.querySelectorAll('img')];

      const insertImages = () => {
        container.querySelectorAll('.insert-img').forEach(el => el.remove());
        insertContainer.insertAdjacentHTML(
          'beforeend',
          images.map((img, j) =>
            `<figure data-id="img_${j + 1}" class="insert-img" style="opacity:0;">${img.outerHTML}</figure>`
          ).join('')
        );
        container.querySelectorAll('.insert-img').forEach(el => {
          setTimeout(() => {
            el.style.opacity = 1;
          }, 50);
        });
      };

      if (i === 0) insertImages();

      new IntersectionObserver(([entry]) => {
        if (entry.isIntersecting) insertImages();
      }, observerOptions).observe(outerContainer);
    });
  });
}
['DOMContentLoaded', 'shopify:section:load'].forEach(event =>
  document.addEventListener(event, newArrivalImageInsert)
);

function videoControlsRemove() {
  const videos = document.querySelectorAll('[data-action="controls-remuve"] video');
  videos.forEach(video => {
    if (video.hasAttribute('controls')) video.removeAttribute('controls.');
  });
}
['DOMContentLoaded', 'shopify:section:load'].forEach(event =>
  document.addEventListener(event, videoControlsRemove)
);

function unMute() {
  const buttons = document.querySelectorAll('.deferred-media__poster-button[data-action="unmute"]');
  buttons.forEach(button => {
    const container = button.closest('deferred-media');
    button.addEventListener('click', () => {
      setTimeout(() => {
        const video = container.querySelector('video');
        try {
          video.removeAttribute('muted');

          video.muted = false;

          video.play().catch(err => {
            console.error('Failed to play video:', err);
          });

          console.log('The sound is on');
        } catch (e) {
          console.error('Error when turning on sound:', e);
        }
      }, 0);
    });
  });
}
['DOMContentLoaded', 'shopify:section:load'].forEach(event =>
  document.addEventListener(event, unMute)
);

// ? tmp
function addSubTitle() {
  const insertContainer = document.querySelector('.collection-heading-title');
  if (!insertContainer) return;
  // console.log('insertContainer.textContent', insertContainer.textContent.trim());
  const breadcrumbLinkCurrent = document.querySelector('.breadcrumb__link--current');
  if (!breadcrumbLinkCurrent) return;
  const collectionName = breadcrumbLinkCurrent?.textContent.trim() ?? null;
  if (!collectionName) return;
  const html = `<span class="sub-title">${collectionName}</span>`;
  if (insertContainer && insertContainer.textContent.trim().toLowerCase() === 'uhrenkatalog' && collectionName.toLowerCase() !== 'produkte') insertContainer.insertAdjacentHTML('beforeend', html);
}
['DOMContentLoaded', 'shopify:section:load'].forEach(event =>
  document.addEventListener(event, addSubTitle)
);

// ? tmp
function hideSearchHomepageElements(){
  const elements = document.querySelectorAll('.predictive-search-form .predictive-search-results__title');
  const noResult = document.querySelector('.predictive-search-results__no-results');
  console.log('noResult', noResult);
  const footer = document.querySelector('.predictive-search-form__footer');

  if (noResult && footer) {
    footer.style.display = 'block';
  } else {
    footer.style.display = '';
  }

  elements.forEach(element => {
    // if (element.textContent.trim() === 'Startseite') element.style.display = 'none';
  });
} 
// ['DOMContentLoaded', 'shopify:section:load'].forEach(event =>
//   document.addEventListener(event, hideSearchHomepageElements)
// );


function historyBack() {
  const container = document.getElementById('back-func-container');
  if (!container) return;
  // console.log('document.referrer', document.referrer);

  const btn = container.querySelector('button[data-role="history-back"]');
  const timer = container.querySelector('span[data-role="back-timer"]');

  if (_lang !== 'de') btn.textContent = 'Back';

  btn?.addEventListener('click', () => {
    window.history.back();
  });

  let n = 5;
  setInterval(() => {
    if (timer && n >= 0) {
      timer.innerHTML = n;
      n--;
    } else {
      window.history.back();
    }
  }, 1000);
}
['DOMContentLoaded', 'shopify:section:load'].forEach(event =>
  document.addEventListener(event, historyBack)
);

